import React, { useState } from 'react'
import { Box, Heading, Flex, Link, Text } from 'front-end/src/components'
import { Trans } from '@lingui/macro'
import { ReccurringEventInDetailFragment } from 'front-end/src/pages/manage-events/components/event-detail/EventDetail.codegen'
import { linkBuilder } from 'shared/linkBuilder'
import dayjs from 'front-end/../shared/dayjs'
import { brandColors } from 'shared/basicPalette'

const NUMBER_OF_SHOWN_ITEMS = 3

export const EventOtherFutureOccurrences = ({
  events,
  eventClosed
}: {
  events: ReccurringEventInDetailFragment[]
  eventClosed: boolean
}) => {
  const [showAll, setShowAll] = useState(false)

  if (!events.length) {
    return null
  }

  return (
    <Box mt="24px">
      <Heading size="md" mb="20px">
        {eventClosed ? (
          <Trans>Other occurrences</Trans>
        ) : (
          <Trans>Other future occurrences</Trans>
        )}
      </Heading>

      {events.map((event, index) => {
        if (!showAll && index >= NUMBER_OF_SHOWN_ITEMS) {
          return
        }
        return (
          <Flex mb="10px" key={event.id}>
            <Text
              color={brandColors.grey.mid}
              fontWeight={700}
              fontSize="14px"
              w="50px"
              mr="8px"
            >
              {dayjs(event.start_time).format('MMM D')}
            </Text>
            <Link to={linkBuilder.eventDetail(event.id)}>{event.title}</Link>
          </Flex>
        )
      })}
      {events.length > NUMBER_OF_SHOWN_ITEMS && (
        <Link onClick={() => setShowAll(!showAll)}>
          {showAll ? <Trans>Hide</Trans> : <Trans>Show all</Trans>}
        </Link>
      )}
    </Box>
  )
}
